import i18next from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import resourcesToBackend from "i18next-resources-to-backend";

// Full EU locale set — we machine-translate all of these, but only the
// SUPPORTED_LOCALES below are exposed in the UI for this release. The rest are
// kept on disk and switched on in a later PR.
const EU_LOCALES = [
  "bg", "cs", "da", "de", "el", "en", "es", "et", "fi", "fr",
  "ga", "hr", "hu", "it", "lt", "lv", "mt", "nl", "pl", "pt",
  "ro", "sk", "sl", "sv",
];

// Languages actually offered in the language switcher for this release.
// Spanish ships as two regional variants (Latin America / Spain).
const SUPPORTED_LOCALES = ["en", "fr", "it", "es-419", "es-ES"];

// Each label in its own language, with the regional variant in parentheses.
// Lives HERE rather than in the sidebar's LocaleSwitcher because it is no
// longer sidebar-only: the phone + OTP login screen needs the same list, and a
// capture user never sees a sidebar. Kept in sync with SUPPORTED_LOCALES.
const LOCALE_LABELS: Record<string, string> = {
  en: "English (United States)",
  fr: "Français (France)",
  it: "Italiano (Italia)",
  "es-419": "Español (Latinoamérica)",
  "es-ES": "Español (España)",
};

i18next
  .use(LanguageDetector)
  .use(
    resourcesToBackend(
      (language: string, namespace: string) =>
        // Tolerate locales that don't yet ship a given namespace (e.g. newer
        // feature namespaces): fall back to an empty bundle so fallbackLng +
        // inline t(key, default) supply the strings instead of throwing.
        import(`./locales/${language}/${namespace}.json`).catch(() => ({ default: {} })),
    ),
  )
  .use(initReactI18next)
  .init({
    fallbackLng: "en",
    supportedLngs: SUPPORTED_LOCALES,
    // Load the exact regional code only (don't strip "es-419"/"es-ES" down to a
    // bare "es", which we don't ship) — fall back straight to English instead.
    load: "currentOnly",
    // "csr" is its own namespace rather than a section of "seafood": Trade Radar
    // and CSR Monitor are separate workflows with separate vocabularies, and CSR
    // is the one a French customer actually reads.
    ns: ["common", "shell", "chat", "inbox", "meetings", "settings", "errors", "packaging", "packagingSpec", "home", "tasks", "pages", "artifacts", "planning", "seafood", "integrations", "capture", "csr", "docverify", "ceoPanel", "opsStatus"],
    defaultNS: "common",
    detection: {
      order: ["localStorage", "navigator"],
      caches: ["localStorage"],
      lookupLocalStorage: "ubik-locale",
    },
    interpolation: { escapeValue: false },
  });

export default i18next;
export { EU_LOCALES, SUPPORTED_LOCALES, LOCALE_LABELS };
